import type { JSX } from 'react';
import { useContext, createContext } from 'react';
import type { Ev1Player } from 'types/e-v1-player-api-types';

const LegacyWistiaPlayerContext = createContext<Ev1Player | null | undefined>(undefined);

type LegacyWistiaPlayerProviderType = {
  children: React.ReactNode;
  player: Ev1Player | null;
};

// WistiaPlayerProvider is used to pass a public api instance of a player to deeply
// nested components that wish to reference its data
export const LegacyWistiaPlayerProvider = ({
  player,
  children,
}: LegacyWistiaPlayerProviderType): JSX.Element => {
  return (
    <LegacyWistiaPlayerContext.Provider value={player}>
      {children}
    </LegacyWistiaPlayerContext.Provider>
  );
};

export const useLegacyWistiaPlayer = (): Ev1Player | null => {
  const player = useContext(LegacyWistiaPlayerContext);
  if (player === undefined) {
    throw new Error('useLegacyWistiaPlayer must be used within a WistiaPlayerProvider');
  }
  return player;
};
